import React from "react";

const VariantBuilderCanvasOutline = ({ rect }) => {
  if (!rect) return null;
  return (
    <div
      className="select-outline"
      style={{
        position: "absolute",
        ...rect,
        boxSizing: "border-box",
        border: "1px solid #003FFF",
        borderRadius: "5px 0px 0px 0px",
        pointerEvents: "none",
      }}
    />
  );
};

export default VariantBuilderCanvasOutline;
